







































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ModalDelete from '@/app/ui/components/ModalDelete/index'
import ModalEdit from './ModalEdit.vue'
import { AdminCMSRoleModule } from '@/app/store/modules/adminCMSRole'

@Component({
  components: {
    'modal-delete': ModalDelete,
    'modal-edit': ModalEdit,
  },
})
export default class extends Vue {
  @Prop({}) public onPageLimit
  @Prop({}) public onPageNumChanged
  @Prop({}) public fields: any[] | undefined
  @Prop({}) public selected: any[] | undefined
  @Prop({}) public dataTable
  @Prop({}) public isLoading

  public modalDelete = {
    id: 'modal-delete',
    idCategory: 0,
    categoryName: '',
  }

  // Form Edit
  public id: number = 0
  public roleName = ''
  public menu: [] = []

  public $refs!: {
    selectableTable: HTMLFormElement
  }

  public funcEdit(item, index, button) {
    this.id = item.id
    this.roleName = item.roleName
    this.menu = item.menu
    this.$root.$emit('bv::show::modal', 'modal-edit-role', button)
  }

  public async patchNotif(item, index, button) {
    const dataToEdit = {
      id: this.id,
      roleName: this.roleName,
      menu: this.menu,
    }

    AdminCMSRoleModule.updateAdminCMSRole(dataToEdit)
    this.$root.$emit('bv::hide::modal', 'modal-edit-role', button)
  }

  public onRowSelected(items) {
    this.$emit('onRowSelected', items)
  }

  public selectAllRows() {
    if (this.$props.selected.length === this.dataTable.data.length) {
      this.$refs.selectableTable.clearSelected()
    } else {
      this.$refs.selectableTable.selectAllRows()
    }
  }

  public get buttonDisable(): boolean {
    if (this.$props.selected.length < 1) {
      return false
    } else {
      return true
    }
  }

  public funcDelete(item, index, button) {
    if (this.$props.selected.length < 1) {
      this.modalDelete.categoryName = item.roleName
      this.modalDelete.idCategory = item.id
      this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
    }
  }
  public deleteNotif() {
    const ids = [this.modalDelete.idCategory]
    AdminCMSRoleModule.deleteAdminCMSRole({ ids })
    this.$root.$emit('bv::hide::modal', 'modal-delete')
  }
}
